import "./header.css";

const Header = () => {
  return (
    <div className="header">
      <div className="headerContainer">
        <h1 className="headerTitle">All The Competitions, The Best ODDs</h1>
      </div>
    </div>
  );
};

export default Header;
